import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';
import { isMessage } from '../../lib/utils';

import { useThemeClassName } from '../../contexts/ThemeContext';

import styles from '../../../styles/partials/page-title.module.scss';

const propTypes = {
    className: PropTypes.string,
    title: AppPropTypes.message,
};

const defaultProps = {
    className: null,
    title: null,
};

function PageTitle({ className, title }) {
    const themeClassName = useThemeClassName(styles);
    const intl = useIntl();

    return (
        <h1 className={classNames([styles.container, themeClassName, className])}>
            {isMessage(title) ? intl.formatMessage(title) : title}
        </h1>
    );
}

PageTitle.propTypes = propTypes;
PageTitle.defaultProps = defaultProps;

export default PageTitle;
